import SpinwheelBillsProcessing from '../../../onboarding/components/billReview/SpinwheelBillsProcessing';

export default function SpinwheelBillsProcessingTestScreen() {
    return <SpinwheelBillsProcessing />;
}
